<template>
  <v-dialog v-model="showModal" persistent :width="width" :max-width="maxWidth">
    <v-card id="modalContainerCard">
      <v-icon id="modalClose" @click="$emit('close-modal')">
        close
      </v-icon>
      <v-card-title class="modal-title">
        {{ modalTitle }}
      </v-card-title>
      <slot />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%'
    },
    maxWidth: {
      type: String,
      default: 'auto'
    },
    modalTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="sass" scoped>
#modalContainerCard
  height: 100%
  width: 100%
#modalClose
  @extend %modal__button-close
.modal-title
  font-size: 2rem
  font-weight: 500
  color: $hwayzBrandGold
  padding-left: 0
</style>
